import { type ReactElement, useCallback, useState } from 'react'
import FilterBarsIcon from '../../../../../../../shared/components/ui/icons/FilterBarsIcon'
import { ExpandedFiltersBy } from './ExpandedFiltersBy'

export function FilterByInput (): ReactElement {
  const [expanded, setExpanded] = useState(false)
  const closeExpanded = useCallback(() => { setExpanded(false) }, [setExpanded])

  return (
    <div className="relative flex-shrink ">
      <button
        className="flex flex-row border bg-gray-200 border-gray-300 hover:border-gray-300 relative"
        onClick={() => { setExpanded(!expanded) }}
      >
        <div className=" mt-2.5 ml-4">
          <FilterBarsIcon />
        </div>
        <div
          className="h-9 px-5 text-lg rounded flex
                   items-center text-gray-700 cursor-pointer"
        >
          Filter
        </div>

      </button>
      {expanded && <ExpandedFiltersBy closeExpanded={closeExpanded} />}
    </div>
  )
}
